<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>桌位点餐</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="tab-content">
        <ol class="goods-classify-list">
          <li
            v-for="item in menuList"
            :key="item.categoryName"
            :class="menuSel == item.goodsCategoryId ? 'active' : ''"
            @click="menuSelAction(item)"
          >
            {{ item.categoryName }}
          </li>
        </ol>
        <div class="goods-container" v-loading="isLoad">
          <div class="goods-list">
            <div class="list" v-if="goodsList.length">
              <el-badge
                :value="item.selNum"
                :hidden="!item.selNum"
                v-for="(item, index) in goodsList"
                :key="index"
              >
                <div class="item" @click="openDialog(index)">
                  <div class="tag-list">
                    <span v-if="item.unitType == 2">计重</span>
                  </div>
                  <img class="pic" :src="item.goodsImage" alt />
                  <div class="info">
                    <p class="title">{{ item.goodsName }}</p>
                    <p class="price">￥{{ item.retailPrice }}</p>
                  </div>
                </div>
              </el-badge>
            </div>
            <div v-else>
              <div class="list-none">
                <img src="@/assets/img/common/list-none.png" alt />
                <p>暂无更多商品</p>
                <el-button
                  type="primary"
                  size="small"
                  @click="linkTo('/goods/edit')"
                  v-if="shopIsMaster"
                  >新建商品</el-button
                >
              </div>
            </div>
          </div>
          <div class="order-action">
            <div class="top">
              <span class="title">{{ orderInfo.tableName }}-客户单</span>
              <el-dropdown @command="changeMealsNum">
                <span class="el-dropdown-link">
                  {{ orderInfo.mealsNum }}人用餐
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu class="btn-menu" slot="dropdown">
                  <el-dropdown-item
                    v-for="item in 20"
                    :key="item"
                    :command="item"
                    >{{ item }}人用餐</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="content-container">
              <div class="product-list">
                <div class="title">
                  <span class="name">菜名</span>
                  <span class="spec">规格/属性</span>
                  <span class="num">数量</span>
                  <span class="price">金额</span>
                </div>
                <div class="list">
                  <div class="inline-title">未下单</div>
                  <div
                    class="item"
                    v-for="(item, index) in productsList"
                    :key="`${item.goodsId}${item.specDesc}`"
                  >
                    <span class="name">{{ item.goodsName }}</span>
                    <span class="spec">{{ item.specDesc }}</span>
                    <span class="num">
                      <span v-if="!isEdit">{{ item.buyCount }}</span>
                      <el-input-number
                        v-else
                        size="mini"
                        v-model="item.buyCount"
                        :min="0"
                        :step="1"
                        @change="productNumChange($event, index)"
                      ></el-input-number>
                    </span>
                    <span class="price"
                      >￥{{
                        (item.turnoverPrice * item.buyCount).toFixed(2)
                      }}</span
                    >
                  </div>
                  <div class="inline-title">已下单</div>
                  <div
                    class="item"
                    v-for="item in inOrderList"
                    :key="`${item.goodsId}${item.specDesc}`"
                  >
                    <span class="name">{{ item.goodsName }}</span>
                    <span class="spec">{{ item.specDesc }}</span>
                    <span class="num">
                      <span>{{ item.buyCount }}</span>
                    </span>
                    <span class="price"
                      >￥{{
                        (item.turnoverPrice * item.buyCount).toFixed(2)
                      }}</span
                    >
                  </div>
                </div>
                <div class="footer">
                  <p>总量：{{ productsList.length + inOrderList.length }}份</p>
                  <p>总计：￥{{ totalMoney.toFixed(2) }}</p>
                  <div>
                    <!-- <p class="remarks" v-if="!isEdit">备注：{{orderInfo.buyerMark}}</p> -->
                    <el-input
                      class="remarks-input"
                      size="mini"
                      v-model="orderInfo.buyerMark"
                      placeholder="请输入备注信息"
                    ></el-input>
                  </div>
                  <div class="action-btn">
                    <el-dropdown
                      trigger="click"
                      @command="changeTable"
                      v-if="isHaveOrder"
                    >
                      <el-button size="small">
                        换桌
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu class="btn-menu" slot="dropdown">
                        <el-dropdown-item
                          v-for="(item, index) in tableList"
                          :key="index"
                          :command="{
                            shoppingTableId: item.shoppingTableId,
                            tableName: item.tableName,
                          }"
                          >{{ item.tableName }}</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                    <el-button size="small" @click="toggleEdit">{{
                      isEdit ? "完成" : "编辑"
                    }}</el-button>
                    <el-button
                      size="small"
                      type="primary"
                      :loading="isPlaceAnOrder"
                      @click="placeAnOrder"
                      >{{ isPlaceAnOrder ? "下单中" : "立即下单" }}</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="order-dialog"
      width="500px"
      :visible.sync="dialogOrderVisible"
    >
      <div slot="title">
        <div class="product-info">
          <img class="pic" :src="product.goodsImage" alt />
          <div class="info">
            <p class="title">{{ product.goodsName }}</p>
            <p class="price">￥{{ Number(product.retailPrice).toFixed(1) }}</p>
            <p class="stock-count">库存：{{ product.totalStockCount }}</p>
          </div>
        </div>
      </div>
      <div class="dialog-content">
        <div class="spec-list">
          <div class="item" v-if="product.products && product.products.length">
            <p class="title">规格选择</p>
            <el-radio-group v-model="proSpec" size="small">
              <el-radio
                :label="index"
                border
                v-for="(specItem, index) in product.products"
                :key="index"
                >{{ specItem.valueContent }}</el-radio
              >
            </el-radio-group>
          </div>
          <div
            class="item"
            v-for="(item, index) in product.freeSpecs"
            :key="index"
          >
            <p class="title">{{ item.name }}</p>

            <el-checkbox-group v-model="freeSpec[index]">
              <el-checkbox
                :label="specItem.value"
                border
                v-for="(specItem, index) in item.specValueList"
                :key="index"
                >{{ specItem.value }}</el-checkbox
              >
            </el-checkbox-group>
            <!-- <el-radio-group v-model="freeSpec[index].value" size="small">
                            <el-radio
                                :label="specItem.value"
                                border
                                v-for="(specItem, index) in item.specValueList"
                                :key="index"
                            >{{specItem.value}}</el-radio>
                        </el-radio-group>-->
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogOrderVisible = false">取消</el-button>
        <el-button type="primary" @click="addProduct()" :loading="isSubmit"
          >点菜</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="order-dialog"
      width="500px"
      :visible.sync="dialogOrderNumberVisible"
    >
      <div slot="title" class="dialog-title">输入取餐码</div>
      <div class="dialog-content">
        <el-input
          v-model="orderInfo.orderNumber"
          placeholder="请输入取餐码"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmOrderNumber">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEdcShopGoodsCategorys,
  getFindAllGoodsPlus,
  getOrderByTable,
  getShopTables,
  getEasySubOrder,
  subOrder,
  changeOrderTable,
  findAllGoodsSample,
} from "@/api/index.js";
import { formatGoodsCategoryListForUI } from "@/utils/goodsCategory";
import {
  isSecondaryCategorySwitchOn,
  getSecondaryCategoryList,
  createBackCategory,
} from "@/utils/secondaryCategory";
import merge from "webpack-merge";
import { Message } from "element-ui";
import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [commonFuc],
  data() {
    return {
      goodsList: [],
      menuList: [
        {
          name: "热销",
          tag: 107761201,
          type: "hot",
        },
        {
          name: "套餐",
          tag: 107761202,
          type: "setMeal",
        },
        {
          name: "主食",
          tag: 107761203,
          type: "stapleFood",
        },
        {
          name: "酒水",
          tag: 107761204,
          type: "wine",
        },
        {
          name: "配菜",
          tag: 107761205,
          type: "garnish",
        },
      ],
      menuListLv1: [],
      menuSel: "hot",
      productsList: [],
      inOrderList: [],
      tableList: [],
      orderInfo: {
        payMoney: 0,
        mealsNum: 1,
        tableName: "",
        orderNumber: "",
      },
      isEdit: false,
      dialogOrderVisible: false,
      product: {},
      freeSpec: [],
      proSpec: 0,
      sampleGoods: [],
      isLoad: false,
      isSubmit: false,
      dialogOrderNumberVisible: false,
      isHaveOrder: true,
      isPlaceAnOrder: false,
      getIndex: 1,
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
    totalMoney() {
      let totalMoney = 0;
      let oldGoodList = [];
      let preSpec = "";
      this.goodsList.forEach((goodsVal) => {
        goodsVal.selNum = 0;
        totalMoney = 0;
        this.productsList.forEach((val) => {
          totalMoney += val.turnoverPrice * val.buyCount;
          if (val.goodsId == goodsVal.goodsId) {
            if (goodsVal.selNum) {
              goodsVal.selNum += val.buyCount;
            } else {
              goodsVal.selNum = val.buyCount;
            }
          }
        });
        this.inOrderList.forEach((val) => {
          totalMoney += val.turnoverPrice * val.buyCount;
          if (val.goodsId == goodsVal.goodsId) {
            if (goodsVal.selNum) {
              goodsVal.selNum += val.buyCount;
            } else {
              goodsVal.selNum = val.buyCount;
            }
          }
        });
      });
      oldGoodList = this.goodsList;
      this.goodsList = [];
      this.goodsList = oldGoodList;
      return totalMoney;
    },
  },
  watch: {
    menuSel() {
      this.getIndex = 1;
      this.getFindAllGoodsPlus();
    },
    proSpec(val) {
      if (this.product.products) {
        this.product.retailPrice = this.product.products[val].retailPrice;
        this.product.totalStockCount = this.product.products[val].stockCount;
      }
    },
  },
  mounted() {
    this.shoppingTableId = this.$route.query.shoppingTableId;
    this.shopId = this.$route.query.shopId;
    this.orderInfo = Object.assign({}, this.orderInfo, {
      tableName: this.$route.query.tableName,
    });
    if (this.$route.query.peopleNumber) {
      this.changeMealsNum(this.$route.query.peopleNumber);
    }
    this.getPageData();
  },
  methods: {
    menuSelAction(item) {
      if (item.goodsCategoryId == "__back__") {
        this.menuList = JSON.parse(JSON.stringify(this.menuListLv1));
        this.menuList.unshift({
          categoryName: "热销",
          goodsCategoryId: "hot",
        });
        this.menuSel = "hot";
        return;
      }
      if (
        isSecondaryCategorySwitchOn() &&
        item.goodsCategoryId != "hot" &&
        Number(item.level) !== 2 &&
        !item.__isParentAll
      ) {
        return getSecondaryCategoryList(item.goodsCategoryId, 99999).then((res) => {
          if (res.code == 1 && res.data && res.data.length) {
            res.data = formatGoodsCategoryListForUI(res.data);
            this.menuList = [
              createBackCategory(),
              {
                categoryName: `${item.categoryName}(全部)`,
                goodsCategoryId: item.goodsCategoryId,
                __isParentAll: true,
              },
              ...res.data,
            ];
          }
          this.menuSel = item.goodsCategoryId;
        });
      }
      this.menuSel = item.goodsCategoryId;
    },
    getFindAllGoodsPlus(i) {
      this.isLoad = true;
      let params = {
        saleStatus: 1,
        row: 50,
        pageNo: i,
        isHideRequired: 1,
      };
      if (this.menuSel == "hot") {
        params.hotSale = 1;
      } else {
        params.goodsCategoryId = this.menuSel;
      }
      getFindAllGoodsPlus(params).then((res) => {
        if (res.code == 1) {
          if (i == 1) {
            this.goodsList = res.data;
          } else {
            this.goodsList = [...this.goodsList, ...res.data];
          }
          this.getFindAllGoodsPlus(this.getIndex++);
        }
        if (res.code == -1) {
          if (i == 1) {
            this.goodsList = [];
          }
          this.isLoad = false;
        }
      });
    },
    changeMealsNum(command) {
      this.orderInfo.mealsNum = command;
      if (this.shop.needChoosePeopleNum) {
        this.findAllGoodsSample();
      }
    },
    changeTable(command) {
      changeOrderTable({
        mallOrderId: this.orderInfo.mallOrderId,
        shoppingTableId: command.shoppingTableId,
      }).then((res) => {
        if (res.code == 1) {
          this.orderInfo = Object.assign({}, this.orderInfo, {
            tableName: command.tableName,
          });
          this.shoppingTableId = command.shoppingTableId;
          this.$router.push({
            query: merge(this.$route.query, {
              shoppingTableId: command.shoppingTableId,
              tableName: command.tableName,
            }),
          });
          this.$notify({
            title: "提示",
            message: "换桌成功",
            type: "success",
            duration: 2000,
          });
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    toggleEdit() {
      this.isEdit = !this.isEdit;
    },
    async getPageData() {
      await getOrderByTable({
        shoppingTableId: this.shoppingTableId,
      }).then((res) => {
        if (res.code == 1) {
          // this.productsList = res.data.products.filter(val => {
          //     if (val.productSaleStatus != 4) {
          //         return val;
          //     }
          // });
          this.inOrderList = res.data.products.filter((val) => {
            if (val.productSaleStatus != 4) {
              return val;
            }
          });
          this.orderInfo = Object.assign({}, this.orderInfo, res.data.extra);
        }
        if (res.code == -1) {
          this.findAllGoodsSample();
          this.isHaveOrder = false;
          // if (!this.shop.isAutoOrderNumber) {
          //     this.dialogOrderNumberVisible = true;
          // }
        }
      });
      getEdcShopGoodsCategorys({
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          res.data = formatGoodsCategoryListForUI(res.data);
          this.menuListLv1 = JSON.parse(JSON.stringify(res.data));
          res.data.unshift({
            categoryName: "热销",
            goodsCategoryId: "hot",
          });
          this.menuList = res.data;
          this.getFindAllGoodsPlus();
        }
      });
      getShopTables({
        status: 0,
      }).then((tablesRes) => {
        if (tablesRes.code == 1) {
          this.tableList = tablesRes.data;
        }
      });
    },
    findAllGoodsSample() {
      findAllGoodsSample({
        isRequired: this.shop.needChoosePeopleNum ? 5 : 4,
      }).then((sampleRes) => {
        if (sampleRes.code == 1) {
          this.sampleGoods = sampleRes.data;
          this.sampleGoods.forEach((val) => {
            // this.productsList.forEach((subval, index) => {
            //     if (val.goodsId == subval.goodsId) {
            //         this.productsList.splice(index, 1);
            //     }
            // });
            this.inOrderList.forEach((subval, index) => {
              if (val.goodsId == subval.goodsId) {
                this.inOrderList.splice(index, 1);
              }
            });
            this.productsList.forEach((subval, index) => {
              if (val.goodsId == subval.goodsId) {
                this.productsList.splice(index, 1);
              }
            });
          });
          this.sampleGoods.forEach((val, index) => {
            for (let i = 0; i < this.orderInfo.mealsNum; i++) {
              this.openDialog(index, "sample");
            }
          });
        }
      });
    },
    productNumChange(val, index) {
      if (val == 0) {
        this.productsList.splice(index, 1);
      }
    },
    openDialog(index, type = "add") {
      if (type == "add") {
        this.product = this.goodsList[index];
      } else {
        this.product = this.sampleGoods[index];
      }
      this.freeSpec = [];
      this.proSpec = 0;
      if (this.product.totalStockCount <= 0) {
        this.$notify({
          title: "提示",
          message: "该商品库存不足",
          type: "warning",
        });
        return;
      }
      if (this.product.freeSpecs && this.product.freeSpecs.length) {
        this.product.freeSpecs.forEach((val) => {
          // this.freeSpec.push({
          //     value: val.specValueList[0].value
          // });
          this.freeSpec.push([]);
        });
      }
      if (
        !(this.product.freeSpecs && this.product.freeSpecs.length) &&
        !(this.product.products && this.product.products.length)
      ) {
        this.addProduct(type);
      } else {
        if (this.product.products && this.product.products.length) {
          this.product.retailPrice = this.product.products[
            this.proSpec
          ].retailPrice;
          this.product.totalStockCount = this.product.products[
            this.proSpec
          ].stockCount;
        }
        this.dialogOrderVisible = true;
      }
    },
    addProduct(type = "add") {
      this.isSubmit = true;
      let products = this.product.products || [];
      let specDesc = products.length ? products[this.proSpec].valueContent : "";
      let isMerge = false;
      let productIndex = 0;
      let freeSpec = [];
      this.freeSpec.forEach((val) => {
        freeSpec.push(...val);
      });
      specDesc += freeSpec.length ? `,${freeSpec.join(",")}` : "";
      if (this.product.totalStockCount <= 0) {
        this.$notify({
          title: "提示",
          message: "该商品库存不足",
          type: "warning",
        });
        this.isSubmit = false;
        return;
      }
      if (this.productsList.length) {
        this.productsList.forEach((val, index) => {
          if (
            val.goodsId == this.product.goodsId &&
            val.goodsCategoryId == this.product.goodsCategoryId &&
            (val.specDesc == specDesc || val.specDesc == undefined)
          ) {
            isMerge = true;
            productIndex = index;
          }
        });
        if (isMerge) {
          this.productsList[productIndex].buyCount++;
        } else {
          this.productsList.push({
            buyCount: 1,
            goodsCategoryId: this.product.goodsCategoryId,
            goodsId: this.product.goodsId,
            goodsName: this.product.goodsName,
            productId: products.length ? products[this.proSpec].productId : "",
            productSaleStatus: 2,
            specDesc: specDesc,
            turnoverPrice: products.length
              ? products[this.proSpec].retailPrice
              : this.product.retailPrice,
          });
        }
      } else {
        this.productsList.push({
          buyCount: 1,
          goodsCategoryId: this.product.goodsCategoryId,
          goodsId: this.product.goodsId,
          goodsName: this.product.goodsName,
          productId: products.length ? products[this.proSpec].productId : "",
          productSaleStatus: 2,
          specDesc: specDesc,
          turnoverPrice: products.length
            ? products[this.proSpec].retailPrice
            : this.product.retailPrice,
        });
      }
      this.productsList = this.productsList;
      if (type == "add") {
        this.$notify({
          title: "提示",
          message: "加菜成功",
          type: "success",
          duration: 1000,
        });
      }
      this.dialogOrderVisible = false;
      setTimeout(() => {
        this.isSubmit = false;
      }, 500);
    },
    placeAnOrder() {
      if (!this.productsList.length) {
        this.$notify({
          title: "提示",
          message: "请先选择商品才能下单",
          type: "warning",
        });
        return;
      }
      let orderList = JSON.parse(JSON.stringify(this.inOrderList));
      let productsList = JSON.parse(JSON.stringify(this.productsList));
      orderList.forEach((val) => {
        productsList.forEach((goodsVal, index) => {
          if (
            val.goodsId == goodsVal.goodsId &&
            val.goodsCategoryId == goodsVal.goodsCategoryId &&
            (val.specDesc == goodsVal.specDesc || val.specDesc == undefined)
          ) {
            val.buyCount += goodsVal.buyCount;
            // productsList.splice(index, 1);
          }
        });
      });
      orderList.push(...productsList);
      this.isPlaceAnOrder = true;
      let payMoney = 0;
      productsList.forEach((val) => {
        payMoney += val.buyCount * val.turnoverPrice;
      });
      // subOrder({
      getEasySubOrder({
        mallOrderId: this.orderInfo.mallOrderId,
        shoppingTableId: this.shoppingTableId,
        // payMoney: this.totalMoney.toFixed(2),
        payMoney: payMoney.toFixed(2),
        productData: JSON.stringify(productsList),
        mealsNum: this.orderInfo.mealsNum,
        buyerMark: this.orderInfo.buyerMark,
        orderNumber: this.orderInfo.orderNumber,
        // shopStoreId: "",
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "下单成功",
            type: "success",
          });
          this.$router.back();
        }
        if (res.code == 0) {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
          });
        }
        this.isPlaceAnOrder = false;
      });
    },
    confirmOrderNumber() {
      if (this.orderInfo.orderNumber) {
        this.dialogOrderNumberVisible = false;
      } else {
        this.$notify({
          title: "提示",
          message: "请输入取餐码",
          type: "error",
          duration: 2000,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .bd {
    height: 100%;
  }
  .tab-content {
    height: calc(100% - 45px);
    .goods-classify-list {
      width: 120px;
      min-width: 120px;
      height: 100%;
      background: #f8f8f8;
      font-size: 12px;
      overflow-y: auto;
      li {
        color: #666666;
        padding-left: 20px;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #eeeeee;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        &.active {
          background: #fff;
        }
      }
    }
  }
  .goods-container {
    display: flex;
    width: calc(100% - 120px);
    padding: 20px;
    padding-top: 0;
    .goods-list {
      flex: 1;
      margin-right: -20px;
      .list {
        height: 100%;
        overflow: auto;
        &::-webkit-scrollbar {
          display: none;
        }
        .el-badge {
          margin: 20px 20px 0 0;
        }
      }
      .item {
        position: relative;
        width: 140px;
        height: 198px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        box-sizing: border-box;
        background: #f8f8f8;
        .tag-list {
          display: inline-block;
          position: absolute;
          left: -1px;
          top: -5px;
          & > span {
            background: #ee3030;
            color: #fff;
            font-size: 12px;
            border-radius: 3px;
            padding: 0 5px;
          }
        }
        .pic {
          width: 100%;
          height: 139px;
          object-fit: cover;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          background: #fff;
        }
        .info {
          font-size: 14px;
          line-height: 14px;
          padding-left: 10px;
          .title {
            font-weight: bold;
            margin-top: 9px;
            color: #333333;
          }
          .price {
            margin-top: 9px;
            color: #ee3030;
          }
        }
      }
      .list-none {
        text-align: center;
        font-size: 14px;
        color: #999999;
        padding-top: 200px;
        & > p {
          margin: 10px 0;
        }
      }
    }
    .order-action {
      width: 300px;
      min-width: 300px;
      height: 100%;
      .top {
        width: 100%;
        padding: 0 20px;
        height: 50px;
        line-height: 50px;
        color: #fff;
        font-size: 14px;
        background: #409eff;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        box-sizing: border-box;
        .el-dropdown {
          float: right;
          color: #fff;
          cursor: pointer;
        }
        .title {
          width: 100px;
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .content-container {
        height: calc(100% - 50px);
        padding: 0 18px;
        border: 1px solid #dcdfe6;
        border-top: 0;
        .product-list {
          height: 100%;
          span {
            display: inline-block;
          }
          .inline-title {
            background: #ccc;
            text-indent: 10px;
          }
          .title {
            line-height: 55px;
            height: 55px;
            font-size: 14px;
            color: #333333;
            border-bottom: 1px dotted #d3d3d3;
            box-sizing: border-box;
          }
          .name {
            width: 92px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: bottom;
            text-indent: 10px;
          }
          .spec {
            width: 62px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: bottom;
          }
          .num {
            width: 50px;
            text-align: center;
            .el-input-number {
              margin-left: -20px;
            }
          }
          .price {
            width: 56px;
            text-align: right;
          }
          .list {
            font-size: 12px;
            line-height: 31px;
            max-height: calc(100% - 225px);
            overflow: auto;
            border-bottom: 1px dotted #d3d3d3;
            padding-bottom: 10px;
            &::-webkit-scrollbar {
              display: none;
            }
          }
          .footer {
            text-align: right;
            font-size: 12px;
            line-height: 12px;
            color: #333333;
            p {
              margin-top: 20px;
            }
            .remarks {
              margin-top: 12px;
              margin-bottom: 20px;
              color: #f57878;
            }
            .remarks-input {
              margin: 4px 0 12px 0;
            }
            .action-btn {
              .el-dropdown {
                margin-right: 10px;
                .el-button {
                  width: 72px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.el-dropdown-menu {
  width: 150px;
}
.content-page {
  .goods-list {
    .el-table {
      .el-table__header {
        .cell {
          line-height: 26px;
        }
      }
      .el-checkbox__label {
        padding-left: 15px;
        vertical-align: middle;
      }
    }
  }
}
.tags-type {
  min-width: 136px !important;
  box-sizing: border-box;
  .el-button--mini {
    padding: 7px 12px;
  }
  .el-radio {
    margin-bottom: 14px;
  }
}
.btn-menu {
  height: 200px;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
.num {
  .el-input-number {
    width: 74px;
    .el-input__inner {
      padding: 0 24px;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 24px;
      box-sizing: border-box;
    }
  }
}
.order-dialog {
  .product-info {
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 20px;
    .pic {
      width: 80px;
      height: 80px;
      object-fit: cover;
    }
    .info {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      .title,
      .price {
        margin-top: 9px;
        font-size: 16px;
        line-height: 16px;
      }
      .title {
        color: #333333;
      }
      .price {
        color: #ee3030;
      }
      .stock-count {
        margin-top: 12px;
        font-size: 12px;
        color: #999999;
        line-height: 12px;
      }
    }
  }
  .dialog-content {
    .spec-list {
      .item {
        margin-bottom: 18px;
        .title {
          font-size: 14px;
          line-height: 14px;
          color: #333333;
          margin: 2px 0 10px 0;
          font-weight: bold;
        }
      }
      .el-checkbox.is-bordered + .el-checkbox.is-bordered {
        margin-left: 0;
      }
      .el-radio.is-bordered + .el-radio.is-bordered {
        margin-left: 0;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
